import { connect } from 'react-redux'

import { login } from '../actions/auth'

import Login from '../components/Login'

const mapStateToProps = state => {
  const { isAuthenticated, name } = state.auth
  return { isAuthenticated, name }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit (values) {
    const { username, password } = values
    dispatch(login(username, password))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js